import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../../../services/apis";
function* handleSendReportEmail(action) {
  const { orderId, emailIds, onSuccess, onFailure } = action.payload;
  
  try {
    const response = yield call(API.sendOrderReportEmail, {
      orderId,
      emailIds,
    });
    
    yield put(actions.sendReportEmailSuccess(response.data));
    
    if (onSuccess) {
      onSuccess(response.data);
    }
  } catch (error) {
    yield put(actions.sendReportEmailFailure(error?.response?.data));
    
    if (onFailure) {
      onFailure(error);
    }
  }
}
export function* shareReportSaga() {
  yield takeLatest(actions.sendReportEmail.type, handleSendReportEmail);
}